<template>
	<div class="tab-pane fade" id="review">
		<div
			class="review-whole-container"
			v-if="!initialLoading && reviews_list.length > 0"
		>
			<div class="row r-1 u-s-m-b-26 u-s-p-b-22">
				<div class="col-lg-6 col-md-6">
					<div class="total-score-wrapper">
						<h6 class="review-h6">Average Rating</h6>
						<div class="circle-wrapper">
							<h1>{{ reviews.aggregate.avg_rating.toFixed(1) }}</h1>
						</div>
						<h6 class="review-h6">Based on {{ reviews.aggregate.no_of_rating }} Reviews</h6>
					</div>
				</div>
				<div class="col-lg-6 col-md-6">
					<div class="total-star-meter">
						<div class="star-wrapper">
							<span>5 Stars</span>
							<div class="star">
								<span style="width: 100%"></span>
							</div>
							<span>({{ getRatingCount(5) }})</span>
						</div>
						<div class="star-wrapper">
							<span>4 Stars</span>
							<div class="star">
								<span style="width: 80%"></span>
							</div>
							<span>({{ getRatingCount(4) }})</span>
						</div>
						<div class="star-wrapper">
							<span>3 Stars</span>
							<div class="star">
								<span style="width: 60%"></span>
							</div>
							<span>({{ getRatingCount(3) }})</span>
						</div>
						<div class="star-wrapper">
							<span>2 Stars</span>
							<div class="star">
								<span style="width: 40%"></span>
							</div>
							<span>({{ getRatingCount(2) }})</span>
						</div>
						<div class="star-wrapper">
							<span>1 Star</span>
							<div class="star">
								<span style="width: 20%"></span>
							</div>
							<span>({{ getRatingCount(1) }})</span>
						</div>
					</div>
				</div>
			</div>
			<!-- Get-Reviews -->
			<div class="get-reviews u-s-p-b-22">
				<!-- Review-Options -->
				<div class="review-options u-s-m-b-16">
					<div class="review-option-heading">
						<h6>
							Reviews
							<span> ({{ reviews.aggregate.no_of_rating }}) </span>
						</h6>
					</div>
					<div class="review-option-box">
						<div class="select-box-wrapper">
							<label class="sr-only" for="review-sort">Review Sorter</label>
							<select
								class="select-box"
								id="review-sort"
								v-model="sortBy"
								@change="onChangeReviewSortHandler"
							>
								<option value="best-rating">Sort by: Best Rating</option>
								<option value="worst-rating">Sort by: Worst Rating</option>
							</select>
						</div>
					</div>
				</div>
				<!-- Review-Options /- -->
				<!-- All-Reviews -->

				<div class="reviewers" v-if="!loading">
					<div class="review-data" v-for="review in reviews_list" :key="review.id">
						<div class="reviewer-name-and-date">
							<h6 class="reviewer-name">
								{{ review.user.name }}
								<span class="badge" v-if="user.id == review.user.id">You</span>&nbsp;
								<!-- <span class="badge" v-if="user.id == review.user.id"><i class="fas fa-pencil-alt"></i></span> -->
							</h6>
							<h6 class="review-posted-date">
								{{ formatDate(review.created_at) }}
							</h6>
							<h6
								class="review-posted-date mt-1"
								v-for="av in review.product_combination.attribute_variations"
								:key="av.id"
							>
								<b>{{ av.attribute.name }} - {{ av.variation.name }}</b>
							</h6>
						</div>
						<div class="reviewer-stars-title-body">
							<div class="reviewer-stars">
								<StarRating
									:increment="1"
									:rating="parseInt(review.rating)"
									:star-size="20"
									:read-only="true"
									:show-rating="false"
								/>
								<span class="review-title">{{ review.review_title }}</span>
							</div>
							<p v-if="review.review.length > 200" class="review-body">
								{{ review.review.substring(0, 200) }}
								<Popper placement="top" :arrow="true">
									<small class="read_more">...Read More</small>
									<template #content>
										<div>{{ review.review }}</div>
									</template>
								</Popper>
							</p>
							<p class="review-body" v-else>{{ review.review }}</p>
						</div>
					</div>
				</div>
				<vue-element-loading
					:active="loading"
					spinner="spinner"
					color="#343a40"
					text="Loading Reviews"
				/>
				<!-- All-Reviews /- -->
				<!-- Pagination-Review -->
				<div class="pagination-review-area" v-if="no_of_pages > 1 && !loading">
					<div class="pagination-review-number">
						<ul>
							<li style="display: none">
								<a href="single-product.html" title="Previous">
									<i class="fas fa-angle-left"></i>
								</a>
							</li>
							<li
								@click.prevent="() => handlePagination(page_no)"
								:class="{active_page: current_page == page_no}"
								v-for="page_no in no_of_pages"
								:key="page_no"
							>
								<a href="">{{ page_no }}</a>
							</li>
						</ul>
					</div>
				</div>
				<!-- Pagination-Review /- -->
			</div>
			<!-- Get-Reviews /- -->
		</div>
		<div
			class="product-not-found"
			v-if="!initialLoading && reviews_list.length == 0"
		>
			<div class="not-found">
				<h2>SORRY!</h2>
				<h6>No Reviews Found.</h6>
			</div>
		</div>
		<Spinner v-if="initialLoading" style="height: 100px" />
	</div>
</template>

<script>
	import axios from "axios";
	import StarRating from "vue-star-rating";
	import Spinner from "../../../Loaders/Spinner.vue";
	import moment from "moment";
	import {mapGetters} from "vuex";
	import Popper from "vue3-popper";
	export default {
		components: {StarRating, Spinner, Popper},
		computed: {
			...mapGetters("auth", ["user"]),
		},
		data() {
			return {
				form: {
					rating: 1, //default rating 1
					review_title: "",
					review: "",
				},
				reviews: "",
				loading: false,
				initialLoading: true,
				sortBy: "best-rating",
				reviews_list: [],
				no_of_pages: 0,
				current_page: 1,
				error: "",
				selectedReview: "",
			};
		},
		methods: {
			formatDate(created_at) {
				return moment(created_at).format("MMMM Do YYYY, h:mm:ss a");
			},
			getRatingCount(rating) {
				//getting the count of reviews with the given rating
				return this.reviews.individual[rating];
			},
			async fetchReviews(product_id, type) {
				this.setLoading(type, true);
				let url =
					process.env.VUE_APP_API_URL +
					"/api/frontend/get-reviews?product_id=" +
					product_id; //url to get reviews
				url = url + "&orderBy=" + this.sortBy; //sorting the reviews
				url = url + "&page=" + this.current_page; //pagination
				let token = localStorage.getItem("token");
				try {
					let {data} = await axios.get(url, {
						headers: {
							Authorization: `Bearer ${token}`,
						},
					});
					console.log("Reviews With Product ID " + product_id, data.payload);
					this.reviews = data.payload;
					this.reviews_list = data.payload.review_list.data;
					this.no_of_pages = data.payload.review_list.last_page; //getting the last page
					this.current_page = data.payload.review_list.current_page; //getting the current page
					this.setLoading(type, false);
				} catch (error) {
					this.error = error;
					console.log(error);
					this.setLoading(type, false);
				}
			},
			onChangeReviewSortHandler() {
				//when the sort by is changed then current page should be 1
				this.current_page = 1;
				this.fetchReviews(this.$route.params.id, "page");
			},
			handlePagination(page_no) {
				//if the page is not the current page
				if (this.current_page != page_no) {
					this.current_page = page_no;
					this.fetchReviews(this.$route.params.id, "page");
				}
			},
			setLoading(type, status) {
				if (type == "initial") {
					this.initialLoading = status;
				}
				if (type == "page") {
					this.loading = status;
				}
			},
		},
		mounted() {
			this.fetchReviews(this.$route.params.id, "initial");
		},
	};
</script>

<style scoped>
	.badge {
		background-color: #343a40;
		color: white;
	}
	.active_page {
		background-color: #343a40;
	}
	.active_page > a {
		color: white !important;
	}
	* {
		--popper-theme-background-color: #ffffff;
		--popper-theme-background-color-hover: #ffffff;
		--popper-theme-text-color: #333333;
		--popper-theme-border-width: 1px;
		--popper-theme-border-style: solid;
		--popper-theme-border-color: #eeeeee;
		--popper-theme-border-radius: 6px;
		--popper-theme-padding: 32px;
		--popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
	}
	.read_more {
		cursor: pointer;
	}
	.product-not-found {
		min-height: 0px;
		height: 150px;
	}
	.fa-pen {
		cursor: pointer;
	}
</style>
